import { useSetAtom } from 'jotai';

import pdpEditOrderErrorMessageAtom from './pdpEditOrderErrorMessageAtom';

const useSetPdpEditOrderErrorMessage = () => {
  const setPdpEditOrderErrorMessage = useSetAtom(pdpEditOrderErrorMessageAtom);

  return setPdpEditOrderErrorMessage;
};

export default useSetPdpEditOrderErrorMessage;
